import { Flex, Link } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { Text } from '../../../../../../ui-components';
import { isBrandsCategory, isSaleCategory } from '../../../../../../utils/category-utils';
import { ChevronRightIcon } from '../../../../../icons';
import type { Categories, Category } from '../../../../../../bff-api/categories/model/category';

interface Props {
    categories: Categories;
    onSelect: (category: Category) => void;
}

export const MenuCategoryMobileLevel12: React.FC<Props> = ({ categories, onSelect }) => (
    <>
        {categories.map((category) => {
            const isSale = isSaleCategory(category);
            const isBrands = isBrandsCategory(category);
            const hasSubCategories = category.subCategories.length > 0;

            return hasSubCategories || isBrands ? (
                <Flex
                    data-testid={`header.menu.mobile.category.${category.ID}`}
                    key={category.ID}
                    alignItems="center"
                    justifyContent="space-between"
                    marginX={4}
                    marginY={3}
                    onClick={(): void => onSelect(category)}
                    cursor="pointer"
                >
                    <Text style="bolder" color={isSale ? 'slt-red-error' : undefined}>
                        {category.displayName}
                    </Text>

                    <ChevronRightIcon />
                </Flex>
            ) : (
                <Link
                    key={category.ID}
                    data-testid={`header.menu.mobile.category.${category.ID}.link`}
                    href={category.url}
                    className="mx-4 my-3"
                >
                    <Text style="bolder" color={isSale ? 'slt-red-error' : undefined}>
                        {category.displayName}
                    </Text>
                </Link>
            );
        })}
    </>
);

MenuCategoryMobileLevel12.propTypes = {
    categories: PropTypes.any.isRequired,
    onSelect: PropTypes.func.isRequired,
};
